const memoizedCookies = /* @__PURE__ */ new Map();
export { memoizedCookies };
